
import flash from './flash';
import scrollLock from './scroll-lock';
import expose from './expose';

export default {
  install(Vue) {
    Vue.directive('flash', flash);
    // 自定义滚动传透指令
    Vue.directive('scroll-lock', scrollLock);
    // 元素曝光指令
    // 注意：指令名必须用项目专属的 'platform-expose'，不可改回通用的 'expose'。
    // 原因：@hb/h5-components-new(广告组件 AdvMaster) 在 import 时会借 window.Vue
    //      自动执行 install，全局注册一个同名的 'expose' 指令，其实现会无条件读取
    //      binding.value.opts.thresholds。一旦两者重名，项目页面里 v-expose 的绑定值
    //      （函数 / { handler, data }，不带 opts）会命中新包指令并抛
    //      "Cannot read properties of undefined (reading 'thresholds')"。
    //      改用独立名以彻底隔离，新增曝光指令请统一使用 v-platform-expose。
    Vue.directive('platform-expose', expose);
  },
};
